import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import Session from "./components/Session";
import UrlHasher from "./components/UrlHasher";
import InitGA from "./components/InitGA";

const container = document.getElementById("fourpc-webscheduler-embed")!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <UrlHasher>
      <Session>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Session>
    </UrlHasher>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
